import script from "./Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search.vue?vue&type=script&setup=true&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=3ef4b4ab&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ef4b4ab"]])

export default __exports__